import React from "react"
import { Link } from "react-router-dom"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Form,
  Alert,
  Input,
  FormFeedback,
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import * as Yup from "yup"
import { useFormik } from "formik"
import withRouter from "components/Common/withRouter"
// import images
import logoLightPng from "../../assets/images/logo-light.png"
import logoDark from "../../assets/images/logo-dark.png"

// Redux actions
import { loginUser } from "../../store/actions"

const Login = props => {
  document.title = "Login | Doctor Web"

  const dispatch = useDispatch()

  // Redux Selector
  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    error: login.error,
  }))
  const { error } = useSelector(LoginProperties)
  const credentialsMap = {
    doctor: { email: "harshit89@gmail.com", password: "Preeti@2345" },
    staff: { email: "shreya900@gmail.com", password: "shreya@1234" },
    admin: { email: "md.ismaaisll@gmail.com", password: "ismail1234" },
  }

  // Formik for form validation
  const validation = useFormik({
    initialValues: {
      email: "ismailshaikh89@gmail.com",
      password: "ismail1234",
      role: "admin",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format")
        .required("Please enter your email"),
      password: Yup.string().required("Please enter your password"),
    }),

    onSubmit: values => {
      dispatch(
        loginUser({
          user: {
            email: values.email.trim(),
            password: values.password.trim(),
            role:values.role,
          },
          history: props.router.navigate,
          callback: () => {
              // console.log(" Saving role in localStorage:", values.role)
               localStorage.setItem("userRoles",values.role)
            // console.log(" Login successful from Login.js")
          },
        }),
      )
    },
  })

  const handleRoleChange = e => {
    const role = e.target.value
    const creds = credentialsMap[role]

    validation.setValues({
      ...validation.values,
      role,
      email: creds.email,
      password: creds.password,
    })
  }

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">
                  <h3 className="text-center mt-5 mb-4">
                    <Link to="/" className="d-block auth-logo">
                      <img
                        src={logoDark}
                        alt=""
                        height="30"
                        className="auth-logo-dark"
                      />
                      <img
                        src={logoLightPng}
                        alt=""
                        height="30"
                        className="auth-logo-light"
                      />
                    </Link>
                  </h3>

                  <div className="p-3">
                    <h4 className="text-muted font-size-18 mb-1 text-center">
                      Welcome Back!
                    </h4>
                    <p className="text-muted text-center">
                      Sign in to continue to doctor web.
                    </p>

                    <Form
                      className="form-horizontal mt-4"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      {error && <Alert color="danger">{error}</Alert>}

                      <div className="mb-3">
                        <Label className="form-label">Login As</Label>
                        <div className="d-flex gap-3">
                          {["doctor", "staff", "admin"].map(role => (
                            <div className="form-check" key={role}>
                              <Input
                                type="radio"
                                name="role"
                                value={role}
                                id={`login-${role}`}
                                onChange={handleRoleChange}
                                checked={validation.values.role === role}
                                className="form-check-input"
                              />
                              <Label
                                className="form-check-label"
                                htmlFor={`login-${role}`}
                              >
                                {role.charAt(0).toUpperCase() + role.slice(1)}
                              </Label>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Email Field */}
                      <div className="mb-3">
                        <Label htmlFor="email">Email</Label>
                        <Input
                          name="email"
                          type="email"
                          placeholder="Enter email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email}
                          invalid={
                            validation.touched.email && validation.errors.email
                          }
                        />
                        {validation.touched.email &&
                          validation.errors.email && (
                            <FormFeedback>
                              {validation.errors.email}
                            </FormFeedback>
                          )}
                      </div>

                      {/* Password Field */}
                      <div className="mb-3">
                        <Label htmlFor="password">Password</Label>
                        <Input
                          name="password"
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                          }
                        />
                        {validation.touched.password &&
                          validation.errors.password && (
                            <FormFeedback>
                              {validation.errors.password}
                            </FormFeedback>
                          )}
                      </div>

                      <div className="mb-3 row mt-4">
                        <div className="col-6">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customControlInline"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customControlInline"
                            >
                              Remember me
                            </label>
                          </div>
                        </div>
                        <div className="col-6 text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            Log In
                          </button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              {/* Forgot Password & Social Login */}
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} Doctor Web
                  <span className="d-none d-sm-inline-block">
                    {" "}
                    - Designed & Developed by &nbsp;
                    <a
                      href="https://ixoratechnologies.in/"
                      target="_blank"
                      style={{
                        testDecoration: "none",
                        color: "inherit",
                        fontWeight: "bold",
                      }}
                    >
                      Ixora Technologies
                    </a>
                  </span>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)
